/* Lagom theme: press module, ported from the prototype's main.js. Loads only when its section is on the page. */
(function () {
  'use strict';
  var L = window.Lagom; if (!L || !L.q) { return; }
  var q = L.q, qa = L.qa, motionOff = L.motionOff, MOTION = L.MOTION, CAPTURE = L.CAPTURE, IMG = L.assetBase || '';
  /* ---------- 2i. Press row ----------
     The CSS loop slows to 30% speed while the pointer is over it (eased by updatePlaybackRate) and pauses while the row
     is off screen, so it costs nothing when you can't see it. */
  (function () {
    var track = q('.press__track');
    if (!track || motionOff() || !track.getAnimations) { return; }
    function anim() { return track.getAnimations()[0]; }
    function rate(r) { var a = anim(); if (a) { if (a.updatePlaybackRate) { a.updatePlaybackRate(r); } else { a.playbackRate = r; } } }
    track.addEventListener('mouseenter', function () { rate(0.3); });
    track.addEventListener('mouseleave', function () { rate(1); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var a = anim(); if (!a) { return; }
        if (entries[0].isIntersecting) { a.play(); } else { a.pause(); }
      }).observe(track);
    }
  })();

})();
